import { formatIsoDateToDisplay, formatToBRL } from 'utils/formatters'
import { Receipt, ReceiptType } from './types'

const PAYMENT_METHOD_LABELS: Record<string, string> = {
  credit_card: 'Cartão de crédito',
  debit_card: 'Cartão de débito',
  pix: 'PIX',
  boleto: 'Boleto',
  bank_transfer: 'Transferência bancária'
}

const REFUND_MODE_LABELS: Record<string, string> = {
  products: 'Estorno de produtos',
  manual: 'Estorno manual',
  exchange: 'Troca'
}

export const RECEIPT_TYPE_LABELS: Record<ReceiptType, string> = {
  payment: 'Pagamento',
  refund: 'Estorno',
  complement: 'Complemento'
}

export function formatPaymentMethod(method?: string | null) {
  if (!method) return '—'
  return PAYMENT_METHOD_LABELS[method] ?? method
}

export function formatRefundMode(refundMode?: string | null) {
  if (!refundMode) return null
  return REFUND_MODE_LABELS[refundMode] ?? refundMode
}

export function buildReceiptDetails(receipt: Receipt) {
  return [
    formatIsoDateToDisplay(receipt.issued_at),
    formatToBRL(receipt.amount),
    formatPaymentMethod(receipt.method),
    receipt.type === 'refund' ? formatRefundMode(receipt.refund_mode) : null,
    receipt.type === 'payment' ? null : receipt.reason
  ]
    .filter(Boolean)
    .join(' • ')
}
